export default __webpack_public_path__ + "static/media/completeProfile-top.2ce035c5.png";